/* eslint-disable react-hooks/exhaustive-deps */
// React
import { useEffect, useLayoutEffect, useRef, useState } from "react";

// Router
import { useNavigate, useParams } from "react-router-dom";

// Redux
import { useDispatch, useSelector } from "react-redux";

import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import {
  clearrequestTxnError,
  reimbursementRequestDetails,
  requestTxnReject,
} from "../../../redux/features/reimbursementRequest/index.js";

// Utils
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
} from "../../../utils/configurationProvider.js";
import formatCurrency from "../../../utils/CurrencyFormater.js";
import formatDateViewAll from "../../../utils/formatDateViewAll.js";
import TEXT from "../../../utils/globalText.js";
import useCategories from "../../../utils/useCategories.js";

// Components / UI
import ICONS from "../../../assets/Icons/index.js";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo/index.jsx";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import TopNavSmallButton from "../../../components/_utils/CommonButtons/TopNavSmallButton/index.jsx";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard/index.jsx";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect/index.jsx";
import SmallPopupWithInput from "../../../components/_utils/CommonSmallPopupWithInput/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber/index.js";
import ReimbursementAccountDetailsPopup from "../../../components/_utils/ReimbursementAccountDetailsPopup/index.jsx";
import TimelineStatusBar from "../../../components/_utils/TimelineCommonComponents/TimelineStatusBar/index.jsx";
import TimelinePopupContent from "../../../components/_utils/TimelinePopupContent/index.jsx";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair/index.jsx";
import OwnerAccountDetailsPopUp from "../../../components/Accounts/OwnerAccount/OwnerAccountDetailsPopUp/index.jsx";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../components/CommonTimeLineCard/index.jsx";
import FullScreen from "../../../components/FullScreen/index.jsx";
import Loader from "../../../components/Loader/Index.jsx";
import ReimburseRequestViewAllPopup from "../../../components/ReimbursementRequest/ReimburseRequestViewAllPopup/index.jsx";
//toast
import { toast } from "react-toastify";
import UniversalRefreshToast from "../../../components/_utils/UniversalRefreshToast/index.jsx";

const ReimbursementTxnRequestDetail = ({
  isPopup,
  txn_id,
  detailSelected,
  reimburse_request_id,
  flow,
  closeDetailModal,
}) => {
  // useDispatch, useNavigate, useParams (and id from params)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  // useRef
  const leftContentRef = useRef(null);
  const detailsTabsScrollRef = useRef(null);
  const cardRefs = useRef({});

  //useState
  const [requestHistory, setRequestHistory] = useState(false);
  const [requestCategory, setRequestCategory] = useState(false);
  const [RequestAccName, setRequestAccName] = useState("");
  const [scheduleUpdatedData, setScheduleUpdatedData] = useState([]);
  const [isloading, setIsLoading] = useState(true);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [BeneAccountId, setBeneAccountId] = useState("");
  const [showRejectPrompt, setShowRejectPrompt] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [showRequestAccModal, setShowRequestAccModal] = useState(false);
  const [OwnerDetailpop, setOwnerDetailpop] = useState(false);
  const [ReimburseAccountDetailpop, setReimburseAccountDetailpop] =
    useState(false);
  const [selectedDetail, setSelectedDetail] = useState(
    flow === "request_additional" || detailSelected === "Additional details"
      ? "Additional details"
      : "Details",
  );

  const supportInfoTTDefaultText = "Copy to clipboard";
  const [supportInfoTT, setSupportInfoTT] = useState(supportInfoTTDefaultText);
  const [showLoader, setShowLoader] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const reasonLength = declineReason.trim().length;
  const isReasonValid =
    reasonLength >= GlobalConfiguration.rejectReasonMinLength;
  const reasonVariant =
    reasonLength === 0 ? "default" : isReasonValid ? "verified" : "error";
  const [RequestCategoryName, setRequestCategoryName] = useState("");
  const [popupCatName, setPopupCatName] = useState("");
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
    Array(scheduleUpdatedData?.[0]?.logs?.length || 0).fill(false),
  );
  const [currentAccountDetails, setcurrentAccountDetails] = useState({
    bankAccountName: "",
    beneAccountId: "",
    bankAccountIFSC: "",
    bankAccountNo: "",
    categories: "",
    amount: "",
    settleType: "",
    bankLogo: "",
    pan: "",
    ownerId: null,
    ownerAccountName: "",
    ownerBankIFSC: null,
    ownerBankBalance: GlobalConfiguration.lengthCheckZero,
    ownerBankLogo: null,
    ownerLastUpdated: null,
    ownerBankAccountNo: null,
    selectedCategory: null,
    mergeCategory: null,
    amountInWords: "",
    labels: [],
    ownerLabels: [],
    comment: "",
    date: "",
    expenseType: "",
    description: "",
    uploadFile: "",
  });
  const [btnClicked, setbtnClicked] = useState({});
  const [tabIndex, setTabIndex] = useState(
    flow === "request_additional"
      ? GlobalConfiguration.lengthCheckOne
      : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");

  //  useSelector
  const services = useSelector((state) => state.refreshToken.services);
  const {
    reimbursementRequestDetailsData,
    requestTxnRejectLoading,
    requestTxnRejectError,
  } = useSelector((s) => s.reimbursementRequest);

  //  Constants (hooks / derived)
  const categoryMapper = useCategories();
  const hasModService = services?.includes("AReimbursementRequest");
  const requestDetails = reimbursementRequestDetailsData?.request?.[0];
  const isRequestApproved = requestDetails?.lifecycle_status === "approved";

  useEffect(() => {
    if (!requestDetails?.request_id) return;

    const showCategoryDetails =
      flow === "request_additional" || detailSelected === "Additional details";
    setSelectedDetail(
      showCategoryDetails
        ? "Additional details"
        : isRequestApproved
          ? "Transaction details"
          : "Details",
    );
    setTabIndex(
      showCategoryDetails
        ? GlobalConfiguration.lengthCheckOne
        : isRequestApproved
          ? GlobalConfiguration.lengthCheckTwo
          : GlobalConfiguration.lengthCheckZero,
    );
  }, [requestDetails?.request_id, isRequestApproved, flow, detailSelected]);

  useEffect(() => {
    const scrollSelectedTab = () => {
      const tabElements =
        detailsTabsScrollRef.current?.querySelectorAll(".switcher-tab");
      const tabKeys = isRequestApproved
        ? ["Transaction details", "Additional details", "Details"]
        : ["Additional details", "Details"];
      const activeIndex = tabKeys.indexOf(selectedDetail);
      const currentTab = tabElements?.[activeIndex];
      if (!currentTab) return;

      const scrollContainer = detailsTabsScrollRef.current;
      if (scrollContainer) {
        const containerRect = scrollContainer.getBoundingClientRect();
        const tabRect = currentTab.getBoundingClientRect();
        const stripStyle = window.getComputedStyle(currentTab.parentElement);
        const leftEdge = containerRect.left + scrollContainer.clientLeft;
        const rightEdge = leftEdge + scrollContainer.clientWidth;
        const left = tabRect.left - (parseFloat(stripStyle.paddingLeft) || 0);
        const right =
          tabRect.right + (parseFloat(stripStyle.paddingRight) || 0);
        let offset =
          left < leftEdge
            ? left - leftEdge
            : right > rightEdge
              ? right - rightEdge
              : 0;

        const maxScroll =
          scrollContainer.scrollWidth - scrollContainer.clientWidth;
        const isMiddleTab =
          activeIndex > 0 && activeIndex < tabElements.length - 1;

        // Center an interior tab to expose its neighbors from either direction.
        if (isMiddleTab && maxScroll > 0) {
          const centeredScroll =
            scrollContainer.scrollLeft +
            tabRect.left +
            tabRect.width / 2 -
            (leftEdge + scrollContainer.clientWidth / 2);
          const targetScroll = Math.max(0, Math.min(maxScroll, centeredScroll));
          offset = targetScroll - scrollContainer.scrollLeft;
        }

        if (Math.abs(offset) > 1) {
          scrollContainer.scrollBy({
            left: offset,
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)")
              .matches
              ? "auto"
              : "smooth",
          });
        }
      }
    };

    const frame = requestAnimationFrame(scrollSelectedTab);
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(scrollSelectedTab, 150);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      cancelAnimationFrame(frame);
      clearTimeout(resizeTimeout);
      window.removeEventListener("resize", handleResize);
    };
  }, [selectedDetail, isRequestApproved, isloading]);

  //useEffect
  useEffect(() => {
    return () => {
      dispatch(clearrequestTxnError());
    };
  }, []);

  // Callbacks
  const toggleAdditionalDetails = () => {
    setSelectedDetail("Additional details");

    setTabIndex(GlobalConfiguration?.lengthCheckOne);
  };
  const toggleDetails = () => {
    setSelectedDetail("Details");
    setTabIndex(GlobalConfiguration?.lengthCheckZero);
  };
  const handleBeneAccModalClose = () => {
    setShowRequestAccModal(false);
    dispatch(
      reimbursementRequestDetails({
        id,
        services,
        navigate,
      }),
    );
  };

  useLayoutEffect(() => {
    if (tabIndex !== prevIndex) {
      const direction =
        tabIndex > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(tabIndex);
    }
  }, [tabIndex]);

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value
      .replace(/[^a-zA-Z0-9\s]/g, "")
      .replace(/^\s+/, "")
      .replace(/\s{2,}/g, " ");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const handleConfirm = async (id, AccountIdData) => {
    setShowLoader(true);
    setShowRejectPrompt(false);

    if (!requestTxnRejectLoading || requestTxnRejectLoading === null) {
      UniversalRefreshToast("internalTxn");
      const result = await dispatch(
        requestTxnReject({ request_ids: [id], AccountIdData }),
      );
      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (result?.payload?.status === false) {
        let error_msg = "";

        if (result?.payload?.errors?.base?.[0]) {
          error_msg = result?.payload?.errors?.base[0]?.errors;
        } else if (result?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = result?.payload?.errors?.bank_account_number[0];
        } else if (!result?.payload?.status) {
          error_msg = result?.payload?.errors?.category?.[0];
        } else {
          error_msg = "An unknown error occurred.";
        }

        setbtnClicked((prev) => ({
          ...prev,
          [scheduleUpdatedData?.transaction?.txn_id]: "none",
        }));
        setShowLoader(false);
        setShowRejectPrompt(false);
        setDeclineReason("");
        toast.dismiss();

        CommonToast({
          text: error_msg,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
        });
      } else {
        const updatedData = scheduleUpdatedData?.request?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status: "rejected",
              rejected_on: result?.payload?.request?.[0]?.rejected_on ?? "",
              rejected_by_name:
                result?.payload?.request?.[0]?.rejected_by_name ?? "",
              rejection_reason: AccountIdData,
              error: "false",
              message: "",
            };
          }
          return item;
        });
        setScheduleUpdatedData((prev) => ({
          ...prev,
          request: updatedData,
        }));
        setScheduleUpdatedData(updatedData);
        setbtnClicked((prev) => ({
          ...prev,
          [scheduleUpdatedData?.transaction?.txn_id]: "none",
        }));
        setShowLoader(false);
        setDeclineReason("");
        setShowRejectPrompt(false);
        // setShowPopup(false);
        toast.dismiss();
        CommonToast({
          text: "Request rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
        });
        if (isPopup) {
          setTimeout(() => {
            closeDetailModal?.();
            window.location.reload();
          }, IntervalConfiguration.intervalMedium);
        }
        await dispatch(reimbursementRequestDetails(reimburse_request_id || id));
      }
    }
  };

  const renderDetailSection = () => {
    if (isloading) return null;

    if (!reimbursementRequestDetailsData?.request?.length) {
      return (
        <div className="text-text-secondary text-font-sm p-padding-md">
          No transaction data available.
        </div>
      );
    }

    switch (tabIndex) {
      case GlobalConfiguration.lengthCheckTwo:
        if (!isRequestApproved) return null;

        return (
          <div
            className={`${animationClass} px-padding-md lg:px-padding-base pb-padding-md`}
          >
            <div className="w-full Qlg:w-details-card-md rounded-border-radius-md bg-primary-card py-padding-md flex flex-col gap-gap-md">
              <p className="text-text-primary text-font-sm font-semibold px-padding-md">
                Transaction Details
              </p>
              <div className="flex justify-between items-center pl-padding-sm pr-padding-md">
                <TitleSubtitlePair
                  title={
                    formatAccountNumber(
                      requestDetails?.owner_account_bank_acc_no,
                    ) || "-"
                  }
                  subtitle={TEXT.SOURCE_ACCOUNT}
                  titleColor="text-primary"
                  isDisabled={isPopup || !services?.includes("VAccount")}
                  onClick={() => {
                    if (!isPopup && services?.includes("VAccount")) {
                      setOwnerDetailpop(true);
                    }
                  }}
                  showArrow={true}
                  alignRight={false}
                  info={false}
                  isBold={false}
                  hoverOption="white"
                  variant="md"
                />
                <CommonBankLogo
                  ifsc={requestDetails?.owner_account_ifsc_code}
                  variant="big"
                  type="pill"
                />
              </div>
              <div className="flex items-center justify-between gap-gap-md px-padding-md">
                <TitleSubtitlePair
                  title={requestDetails?.owner_account_ifsc_code || "-"}
                  subtitle={TEXT.IFSC_CODE}
                  titleColor="text-primary"
                  alignRight={false}
                  info={false}
                  showArrow={false}
                  isBold={false}
                  variant="md"
                />
              </div>
              <div className="px-padding-md">
                <TitleSubtitlePair
                  title={requestDetails?.payment_method || "-"}
                  subtitle="Payment method"
                  titleColor="text-primary"
                  alignRight={false}
                  info={false}
                  showArrow={false}
                  isBold={false}
                  variant="md"
                />
              </div>
            </div>
          </div>
        );

      // ===================== DETAILS =====================
      case GlobalConfiguration?.lengthCheckZero:
        return reimbursementRequestDetailsData?.request?.map((account) => {
          const originItemList = [
            {
              heading: "Requested by",
              content: account?.logs[0]?.user_full_name,
              type: "text",
            },
            {
              heading: "Requested on",
              content: formatDateViewAll(
                reimbursementRequestDetailsData?.request?.[0]?.created_on,
                true,
                true,
              ),
              type: "text",
            },
            {
              heading: "User ID",
              content: account?.created_by_name,
              type: "text",
            },
          ];

          const statusItemList = [
            ...(account?.lifecycle_status === "approved"
              ? [
                  {
                    heading: "Approved by",
                    content: account?.logs[1]?.user_full_name,
                    type: "text",
                  },
                  {
                    heading: "Approved on",
                    content:
                      account?.approved_at != null
                        ? formatDateViewAll(account?.approved_at, true, true)
                        : "-",
                    type: "text",
                  },
                  {
                    heading: "User ID",
                    content: account?.logs[1]?.user_full_name,
                    type: "text",
                  },
                ]
              : [
                  {
                    heading: "Rejected by",
                    content: account?.logs[1]?.user_full_name,
                    type: "text",
                  },
                  {
                    heading: "Rejected on",
                    content:
                      account?.rejected_at != null
                        ? formatDateViewAll(account?.rejected_at, true, true)
                        : "-",
                    type: "text",
                  },
                  {
                    heading: "User ID",
                    content: account?.logs[1]?.user_full_name,
                    type: "text",
                  },
                ]),
          ];

          const supportItemList = [
            {
              content: account?.request_id,
              heading: "Request ID",
              type: "textWithButton",
              iconArray: [
                {
                  onClick: (e) => {
                    setSupportInfoTT("Copied");
                    if (account?.request_id) {
                      navigator.clipboard.writeText(account.request_id);
                    }
                    setTimeout(() => {
                      setSupportInfoTT(supportInfoTTDefaultText);
                    }, IntervalConfiguration.intervalMedium);
                  },
                  title: supportInfoTT,
                  icon:
                    supportInfoTT === "Copied"
                      ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                      : ICONS?.COPY,
                },
              ],
            },
          ];

          return (
            <div
              key={tabIndex}
              className={animationClass}
            >
              <div
                key={account.request_id}
                className="flex flex-col lg:flex-row mb-margin-md px-padding-md lg:px-padding-base gap-gap-md"
              >
                <CommonDetailCard
                  cardTitle={TEXT?.ORIGIN_DETAILS}
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={originItemList}
                />
                {account?.lifecycle_status !== "pending" && (
                  <CommonDetailCard
                    cardTitle={
                      account?.lifecycle_status === "approved"
                        ? "Approval Details"
                        : "Rejection Details"
                    }
                    variant="third"
                    numCols={GlobalConfiguration?.lengthCheckOne}
                    entries={statusItemList}
                  />
                )}
                <CommonDetailCard
                  cardTitle="Support information"
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={supportItemList}
                />
              </div>
            </div>
          );
        });

      // ===================== ADDITIONAL DETAILS =====================
      case GlobalConfiguration?.lengthCheckOne: {
        const allAdditionalData =
          reimbursementRequestDetailsData.request.flatMap(
            (txn) => txn.additional_data?.data ?? [],
          );

        const attachments = allAdditionalData.filter((item) =>
          ["hyperlink", "upload"].includes(item.data_type),
        );

        if (!allAdditionalData.length) {
          return (
            <div
              key={tabIndex}
              className={animationClass}
            >
              <div className="max-w-search-min-width flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md mx-margin-md Qlg:mx-margin-base">
                <div className="text-text-primary text-font-sm font-semibold">
                  {TEXT?.CATEGORY_SPECIFIC_DETAILS}
                </div>
                <p className="text-text-secondary text-font-xs font-normal">
                  Additional details are not supported for the selected
                  category.
                </p>
              </div>
            </div>
          );
        }

        const attachmentEntries = attachments
          .map((obj) => {
            if (obj.data_type === "hyperlink" && obj.value) {
              return {
                heading: "URL",
                content: obj.value,
                type: "link",
              };
            }

            if (obj.data_type === "upload") {
              const file = obj.value;
              if (!file?.metadata) return null;

              const mt = (
                file.metadata.mime_type ?? "application/octet-stream"
              ).toLowerCase();

              const isImage = ["image/png", "image/jpeg", "image/jpg"].includes(
                mt,
              );

              return {
                heading: isImage ? "Image" : "File",
                type: isImage ? "image" : "file",
                content: {
                  fileName: file.metadata.filename,
                  size: file.metadata.size ?? "0",
                  mimeType: mt,
                  url: file.file_url || file.id,
                },
              };
            }

            return null;
          })
          .filter(Boolean);

        const additionalDetailEntries = allAdditionalData
          .map((item) => {
            if (item.data_type === "from_year_to_year") {
              const { from, to } = item.value || {};
              return {
                heading: item.name,
                content: from && to ? `${from} - ${to}` : "Not Given",
                type: "text",
              };
            }

            if (item.data_type === "date_range") {
              const { start_date, end_date } = item.value || {};
              return {
                heading: item.name,
                content:
                  start_date && end_date
                    ? `${start_date} - ${end_date}`
                    : "Not Given",
                type: "text",
              };
            }

            if (
              !["hyperlink", "upload", "multi_select_list", "toggle"].includes(
                item.data_type,
              )
            ) {
              return {
                heading: item.name,
                content: item?.value ? item?.value : "Not Given",
                type: "text",
              };
            }

            if (item.data_type === "multi_select_list") {
              return {
                heading: item.name,
                content: item.value?.length
                  ? item.value.join(", ")
                  : "Not Given",
                type: "text",
              };
            }

            if (item.data_type === "toggle") {
              return {
                heading: item.name,
                content: item.value ? "Yes" : "No",
                type: "text",
              };
            }

            return null;
          })
          .filter(Boolean);

        return (
          <div
            key={tabIndex}
            className={animationClass}
          >
            <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary px-padding-md lg:px-padding-base">
              {additionalDetailEntries.length >
                GlobalConfiguration?.lengthCheckZero && (
                <CommonDetailCard
                  cardTitle={TEXT?.CATEGORY_SPECIFIC_DETAILS}
                  variant="third"
                  numCols={
                    allAdditionalData.length ===
                    GlobalConfiguration?.lengthCheckOne
                      ? GlobalConfiguration?.lengthCheckOne
                      : GlobalConfiguration?.lengthCheckTwo
                  }
                  entries={additionalDetailEntries}
                />
              )}

              {attachmentEntries.length >
                GlobalConfiguration?.lengthCheckZero && (
                <CommonDetailCard
                  cardTitle={TEXT?.ATTACHMENTS}
                  variant="third"
                  numCols={GlobalConfiguration?.lengthCheckOne}
                  entries={attachmentEntries}
                />
              )}
            </div>
          </div>
        );
      }

      default:
        return null;
    }
  };

  useEffect(() => {
    dispatch(disableSwitcher());
  }, [services, id, navigate]);

  useEffect(() => {
    fetchData();
  }, [id, reimburse_request_id]);

  // useEffect(() => {
  //   if (
  //     Array.isArray(scheduleUpdatedData?.request) &&
  //     scheduleUpdatedData.request.length
  //   ) {
  //     const data = scheduleUpdatedData.request[0];
  //     if (type === "reimbursereq_details") {
  //       if (data?.request_id !== reimburse_request_id) return;
  //     } else {
  //       if (data?.request_id !== id) return;
  //     }
  //     setDoneBinding(true);
  //   }
  // }, [scheduleUpdatedData, id]);

  const categoryIcon = categoryMapper(
    reimbursementRequestDetailsData?.request?.[0]?.category_id.category_id,
  );

  const quickActions = (
    <>
      <div className="flex flex-col w-width-full mb-margin-md">
        <div className="py-padding-sm px-padding-md bg-primary-card text-font-sm text-text-primary text-left font-semibold w-width-full">
          Quick Action
        </div>

        {(() => {
          const buttonsTop = [];
          const buttonsBottom = [];

          buttonsTop.push(
            <TopNavSmallButton
              btnText={
                reimbursementRequestDetailsData?.request?.[0]?.category_id
                  ?.category_name ?? ""
              }
              btnType="button"
              icon={categoryIcon?.url}
              imgColor={categoryIcon?.colour}
              handleFunction={() => {
                if (isPopup) {
                  CommonToast({
                    text: "Action restricted in popup mode.",
                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                    variant: "var(--error)",
                  });
                  return;
                } else {
                  setRequestHistory(true);
                  setRequestCategoryName(
                    reimbursementRequestDetailsData?.request?.[0]?.category_id
                      ?.category_id ?? "",
                  );
                  setRequestAccName(
                    reimbursementRequestDetailsData?.request?.[0]
                      ?.beneficiary_account_name,
                  );
                  setRequestId(
                    reimbursementRequestDetailsData?.request?.[0]
                      ?.beneficiary_account_id,
                  );
                }
              }}
              isDisabled={isPopup ? true : false}
              enabledTextColor="var(--text-primary)"
              enabledBgColor="var(--primary-nav-act)"
              disabledBgColor="var(--primary-nav-act)"
              hoverOption="white"
              fullWidthRequired={true}
            />,
          );
          if (
            reimbursementRequestDetailsData?.request?.[0]?.lifecycle_status ===
            "approved"
          ) {
            buttonsBottom.push(
              <TopNavSmallButton
                btnText={
                  <>
                    Linked <br /> transaction
                  </>
                }
                icon={ICONS?.LINKED_WHITE_CIRCLE}
                hoverOption={"white"}
                enabledBgColor={"var(--primary-nav-act)"}
                enabledTextColor={"var(--text-primary)"}
                disabledBgColor={"var(--primary-nav-act)"}
                disabledTextColor={"var(--text-primary)"}
                fullWidthRequired
                handleFunction={() => {
                  navigate(
                    `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${reimbursementRequestDetailsData?.request?.[0]?.beneficiary_transactions_details?.beneficiary_transaction_id}`,
                  );
                }}
                isDisabled={isPopup}
              />,
            );
          }

          return (
            <>
              <div
                className={`grid w-width-full bg-primary-nav ${
                  buttonsTop.length === GlobalConfiguration?.lengthCheckOne
                    ? "grid-cols-1"
                    : "grid-cols-2"
                } border-b ${
                  buttonsBottom.length > GlobalConfiguration?.lengthCheckZero
                    ? "border-primary-bg"
                    : "border-none"
                }`}
              >
                {buttonsTop.map((btn, index) => (
                  <div
                    key={index}
                    className="relative border-r border-primary-bg last:border-none"
                  >
                    {btn}
                  </div>
                ))}
              </div>

              {/* Bottom Row (Confidential full width if exists) */}
              {buttonsBottom.length > GlobalConfiguration?.lengthCheckZero && (
                <div className=" w-width-full bg-primary-nav">
                  {buttonsBottom.map((btn, index) => (
                    <div
                      key={index}
                      className="relative border-r border-primary-bg last:border-none"
                    >
                      {btn}
                    </div>
                  ))}
                </div>
              )}
            </>
          );
        })()}
      </div>
    </>
  );

  async function fetchData() {
    setIsLoading(true);
    try {
      let response;

      response = await dispatch(
        reimbursementRequestDetails(reimburse_request_id || id),
      );

      if (response?.error?.message === "Request failed with status code 404") {
        navigate("/*");
      }
    } catch (error) {
      error("Failed to load the account details", error);
    } finally {
      setIsLoading(false);
    }
  }

  const closeHistory = () => {
    setRequestHistory(false);
    setRequestAccName("");
    setRequestId("");
    setRequestCategoryName("");
    setPopupCatName("");
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });

    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };
  const handleTimelinePopup = () => {
    SetopenTimelinePopup(true);
    setShowApprovalTimeline(true);
  };
  const PopupcloseIcons = () => {
    setOpenApprovalTimeline([]);
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
  };

  useEffect(() => {
    if (!reimbursementRequestDetailsData) return;

    const uiState = addLifeCycleStatus({
      lifecycle_status:
        reimbursementRequestDetailsData?.request?.[0]?.lifecycle_status,
      services,
      cardType: "single",
    });

    const newData = {
      ...reimbursementRequestDetailsData,
      transaction: reimbursementRequestDetailsData?.request?.map((account) => ({
        ...account,
        loading: false,
        error: false,
        message: "",
        last_updated_user_id_check: false,
        ...uiState,
      })),
    };

    // setTimelinedatabottom(newData);

    setScheduleUpdatedData(newData);
  }, [reimbursementRequestDetailsData, services]);
  const rejectErrorMessage = requestTxnRejectError?.errors?.base?.[0]?.errors;

  return (
    <>
      <div
        className={`  flex flex-col overflow-x-hidden  ${!isPopup ? "overflow-y-auto  h-screen" : "h-full"}`}
      >
        {requestHistory && (
          <>
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <ReimburseRequestViewAllPopup
                closeReimburseTxnDetailsModal={closeHistory}
                TxnHistoryid={requestId}
                TxnHistoryAccountName={RequestAccName}
                categoryName={RequestCategoryName}
                type={"requestViewallPopup"}
                flow="requestHistory"
                popupCatName={popupCatName}
              />
            </div>
          </>
        )}
        {requestCategory && (
          <>
            <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
              <ReimburseRequestViewAllPopup
                closeReimburseTxnDetailsModal={(e) => {
                  setRequestCategory(false);
                  setRequestAccName("");
                  setRequestId("");
                  setRequestCategoryName("");
                  setPopupCatName("");
                }}
                TxnHistoryid={requestId}
                TxnHistoryAccountName={RequestAccName}
                categoryName={RequestCategoryName}
                popupCatName={popupCatName}
                type={"requestViewallPopup"}
                flow="requestCategory"
              />
            </div>
          </>
        )}
        {OwnerDetailpop && (
          <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
            <OwnerAccountDetailsPopUp
              closeBeneAccountDetailModal={() => {
                setOwnerDetailpop(false);
              }}
              Remibursement_owneraccount_id={
                reimbursementRequestDetailsData?.request?.[0]?.owner_account_id
              }
              type={"reimburseowner_details"}
            />
          </div>
        )}
        {ReimburseAccountDetailpop && (
          <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
            <ReimbursementAccountDetailsPopup
              closeBeneAccountDetailModal={() => {
                setReimburseAccountDetailpop(false);
              }}
              reimburse_account_id={BeneAccountId}
              type={"reimburseacc_details"}
            />
          </div>
        )}

        {showRejectPrompt && (
          <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
            <SmallPopupWithInput
              headerTitle="Reject request"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              textSize="font-md"
              noteText="Minimum 10 characters required."
              secondHeaderTitle="Provide the reason for rejection."
              secondHeaderFontWeight="normal"
              secondHeaderFontColor="text-secondary"
              secondHeaderTextSize="font-xs"
              noteColor="text-secondary"
              inputPlaceholder={TEXT.REASON}
              inputVariant={reasonVariant}
              inputIsDisabled={showLoader ? true : false}
              btnOneIsDisabled={showLoader ? true : false}
              inputBgColor="var(--primary-bg)"
              inputFgColor="var(--text-secondary)"
              inputOnInput={(e) => {
                if (!showLoader) {
                  handleInputChange(e);
                }
              }}
              inputValue={declineReason}
              inputFontKind="big"
              inputIsFullWidth={true}
              btnOneText="Cancel"
              btnOneHandleFunction={() => {
                if (!showLoader) {
                  setShowRejectPrompt(false);
                  setDeclineReason("");
                  setbtnClicked((prev) => ({
                    ...prev,
                    [scheduleUpdatedData?.transaction?.txn_id]: "none",
                  }));
                }
              }}
              btnOneEnabledBgColor="var(--primary-bg)"
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneHoverOption="white"
              btnTwoText="Reject"
              btnTwoHandleFunction={() => {
                if (!isReasonValid || showLoader) {
                  return;
                }
                handleConfirm(
                  reimbursementRequestDetailsData?.request?.[0]?.request_id,
                  declineReason,
                );
              }}
              btnTwoEnabledBgColor="var(--negative-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={!isReasonValid || showLoader}
              btnTwoDisabledBgColor="var(--text-disabled)"
              btnTwoInActiveVariantNeeded={true}
              btnTwoIsLoaderNeeded={showLoader ? true : false}
              btnTwoIsLoading={showLoader ? true : false}
              btnTwoHoverOption="black"
              bulletPoints={[
                "Once the request is rejected, the transaction will not be created, and a new request must be created.",
              ]}
            />
          </div>
        )}
        {opentimelinepopup && (
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Request timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType="button"
              closeiconisDisabled={false}
              closeicondisabledBgColor=""
              closeiconbuttonRef={null}
              closeicontitle="Close"
              btnType="button"
              handleFunction={() => {}}
              enabledBgColor="var(--positive-act)"
              hoverOption="dark"
              outLineColor=""
              enabledTextColor="var(--text-primary)"
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor=""
              disabledBgColor=""
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={scheduleUpdatedData?.transaction}
                handleApprovalClick={handleTimelinePopup}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"single"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        )}
        {showRequestAccModal && (
          <div
            className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-custom-backdrop bg-opacity-dark-opacity"
            onClick={() => {
              handleBeneAccModalClose();
            }}
          >
            <LargePopupRedirect
              headerTitle="Request Account Details"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headersubtext=""
              headertextSize="font-md"
              isfullViewrequired={true}
              fullviewbtnText="Open in full view"
              fullviewbtnType="button"
              fullviewhandleFunction={() => {
                handleBeneAccModalClose();
                navigate(
                  `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${reimbursementRequestDetailsData?.request?.[0]?.beneficiary_account_id}`,
                );
              }}
              fullviewisDisabled={false}
              fullviewenabledTextColor="var(--text-primary)"
              fullviewenabledBgColor="var(--primary-nav)"
              fullviewdisabledBgColor="var(--text-disabled)"
              fullviewhoverOption="white"
              fullviewicon={ICONS?.REDIRECT}
              closeiconbtnType="button"
              closeiconhandleFunction={handleBeneAccModalClose}
              closeiconisDisabled={false}
              closeiconenabledBgColor="var(--primary-nav)"
              closeicondisabledBgColor="var(--text-disabled)"
              closeiconhoverOption="white"
              closeicon={ICONS?.CLOSE}
              isbottomSectionneed={false}
              bottomHeaderTextNeed={false}
              isscrollRequired={true}
            >
              <div onClick={(e) => e.stopPropagation()}>
                <ReimbursementAccountDetailsPopup
                  reimburse_account_id={
                    reimbursementRequestDetailsData?.request?.[0]
                      ?.beneficiary_account_id ?? ""
                  }
                  closeBeneAccountDetailModal={handleBeneAccModalClose}
                  type={"reimburseacc_details"}
                  payload={{
                    bene_account_id:
                      reimbursementRequestDetailsData?.request?.[0]
                        ?.beneficiary_account_id ?? "",
                    type: "reimburseacc_details",
                  }}
                  // servicesType="RAAccount"
                />
              </div>
            </LargePopupRedirect>
          </div>
        )}
        {!isPopup && (
          <>
            <div className="sched-mobile-nav-bar fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-overlay bg-primary-nav shadow-box-shadow-bottom lg:hidden block">
              <TopNavComponent
                isFormattingNotRequired={true}
                topNavHeader={"Reimbursement"}
                topNavSubText="Request details"
              />
            </div>
          </>
        )}
        {alertPopUp && (
          <div className="fixed top-top-base left-left-base w-width-full h-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <FullScreen
              id={txn_id ?? ""}
              setAlertPopUp={setAlertPopUp}
              type={"Schedule_Internal_Txn"}
            />
          </div>
        )}
        {!isPopup && (
          <div className="Qsmd:h-navbar-breadcrumb-height h-navbar-height bg-primary-nav hidden flex-shrink-0 Qmd:block"></div>
        )}

        {isloading ? (
          <div className="w-width-full flex-1 flex flex-row justify-center items-center">
            <Loader />
          </div>
        ) : (
          <>
            <div className={`bg-primary-bg`}>
              <>
                <div className="sched-detail-section hidden bg-primary-nav Qmd:flex flex-row justify-center relative">
                  <div
                    className={`sched-detail-section-inner-1024 Qlg:max-w-tab-width-normal Qlg:w-std-width Qmd:w-width-full relative `}
                  >
                    <div className="h-auto  flex flex-row justify-center items-stretch">
                      <div className="sched-schedule-name-div w-width-full flex flex-row justify-between items-center py-padding-md Qmd:w-width-md-2-3">
                        <div className="pl-padding-sm">
                          <TitleSubtitlePair
                            title={`INR ${formatCurrency(reimbursementRequestDetailsData?.request?.[0]?.requested_amount)}`}
                            titleColor={
                              reimbursementRequestDetailsData?.request?.[0]
                                ?.lifecycle_status === "rejected" ||
                              reimbursementRequestDetailsData?.request?.[0]
                                ?.lifecycle_status === "pending" ||
                              reimbursementRequestDetailsData?.request?.[0]
                                ?.requested_amount ===
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.reimbursement_amount
                                ? "text-primary"
                                : "queued"
                            }
                            subtitle={"Requested amount"}
                            info={false}
                            alignRight={false}
                            hoverOption="white"
                            isBold={true}
                            variant="md"
                          />
                        </div>
                        {reimbursementRequestDetailsData?.request?.[0]
                          ?.approved === "Y" &&
                          (reimbursementRequestDetailsData?.request?.[0]
                            ?.reimbursement_amount !== undefined ||
                            reimbursementRequestDetailsData?.request?.[0]
                              ?.reimbursement_amount !== null) && (
                            <div>
                              <TitleSubtitlePair
                                title={`INR ${formatCurrency(reimbursementRequestDetailsData?.request?.[0]?.reimbursement_amount)}`}
                                titleColor="settled"
                                subtitle={"Approved amount"}
                                info={false}
                                alignRight={true}
                                textAlign="right"
                                hoverOption="white"
                                isBold={true}
                                variant="md"
                              />
                            </div>
                          )}
                      </div>

                      <div className="border-r border-solid border-primary-bg mx-margin-md my-margin-md"></div>
                      <div className="sched-txn-amount-div w-width-full flex flex-row justify-between items-center">
                        <div className="py-padding-md">
                          <TitleSubtitlePair
                            title={
                              reimbursementRequestDetailsData?.request?.[0]
                                ?.beneficiary_account_name
                            }
                            titleColor="text-primary"
                            subtitle="Account name"
                            info={false}
                            alignRight={false}
                            hoverOption="white"
                            isBold={false}
                            variant="md"
                          />
                        </div>
                        <div className="hidden Qmd:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base h-height-full">
                          <div className="Qmd:flex flex-row overflow-hidden justify-end w-auto h-height-full bg-primary-nav-act">
                            <TopNavSmallButton
                              btnText={
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.category_id?.category_name
                              }
                              btnType="button"
                              icon={categoryIcon.url}
                              imgColor={categoryIcon.colour}
                              handleFunction={() => {
                                if (isPopup) {
                                  CommonToast({
                                    text: "Action restricted in popup mode.",
                                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                  return;
                                } else {
                                  setRequestCategory(true);
                                  setRequestCategoryName(
                                    reimbursementRequestDetailsData
                                      ?.request?.[0]?.category_id
                                      ?.category_name,
                                  );
                                  setRequestAccName(
                                    reimbursementRequestDetailsData
                                      ?.request?.[0]?.beneficiary_account_name,
                                  );
                                  setRequestId(
                                    reimbursementRequestDetailsData
                                      ?.request?.[0]?.beneficiary_account_id,
                                  );
                                }
                              }}
                              isDisabled={isPopup ? true : false}
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              disabledBgColor="var(--primary-nav-act)"
                              hoverOption="white"
                              fullWidthRequired={false}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr className="border-primary-bg"></hr>
                    <div className="flex flex-row justify-center relative">
                      <div className="sched-source-side w-width-full flex flex-col items-center justify-around Qmd:pb-padding-md Qmd:pt-padding-sm Qsmd:w-width-md-2-3">
                        <div
                          className={`sched-source-acct-bank Qmd:translate-x-[-0.5rem] flex flex-row items-center justify-between w-width-full pl-padding-sm`}
                        >
                          <div
                            className={` ${isPopup && "opacity-light-opacity"}`}
                          >
                            <TitleSubtitlePair
                              isDisabled={
                                isPopup ||
                                !(
                                  services?.includes("RVAccount") ||
                                  services?.includes("Admin")
                                )
                                  ? true
                                  : false
                              }
                              alignRight={false}
                              title={formatAccountNumber(
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.beneficiary_account_bank_acc_no,
                              )}
                              titleColor={"text-primary"}
                              subtitle={"Destination account"}
                              onClick={() => {
                                if (isPopup) {
                                  CommonToast({
                                    text: "Action restricted in popup mode.",
                                    icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                    variant: "var(--error)",
                                  });
                                } else {
                                  if (
                                    services?.includes("RVAccount") ||
                                    services?.includes("Admin")
                                  ) {
                                    setReimburseAccountDetailpop(true);
                                    setBeneAccountId(
                                      reimbursementRequestDetailsData
                                        ?.request?.[0]?.beneficiary_account_id,
                                    );
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "RVAccount, Admin",
                                      },
                                    });
                                  }
                                }
                              }}
                              info={false}
                              showArrow={true}
                              hoverOption={"white"}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>

                          <div
                            className={`bg-text-primary rounded-full p-padding-sm flex flex-row justify-center items-center px-padding-sm py-padding-button-s mr-margin-md`}
                          >
                            <CommonBankLogo
                              ifsc={
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.beneficiary_account_ifsc_code
                              }
                              variant="big"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="border-r border-solid border-primary-bg mx-margin-md my-margin-md"></div>
                      <div
                        className={`sched-dest-side w-width-full flex flex-col  ${"justify-around"}`}
                      >
                        <div className="sched-dest-acct-bank flex flex-row items-center justify-between w-width-full h-full">
                          <div className="flex justify-between mr-margin-md w-full">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={false}
                              title={
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.beneficiary_account_ifsc_code
                              }
                              titleColor={"text-primary"}
                              subtitle={TEXT?.IFSC_CODE}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>
                          <div className="hidden Qmd:flex flex-col justify-end gap-gap-base mr-margin_margin-md ml-margin-base h-height-full">
                            <div className="Qmd:flex flex-row overflow-hidden justify-end  h-height-full">
                              <div
                                className={`hidden Qmd:flex flex-row justify-end align-bottom h-auto`}
                                style={{
                                  width:
                                    "calc(var(--positive-negative-btn-width) + var(--positive-negative-btn-width))",
                                }}
                              >
                                <div className="w-width-md overflow-hidden">
                                  {reimbursementRequestDetailsData?.request?.[0]
                                    ?.lifecycle_status === "approved" && (
                                    <>
                                      <TopNavSmallButton
                                        btnText={
                                          <>
                                            Linked <br /> transaction
                                          </>
                                        }
                                        icon={ICONS?.LINKED_WHITE_CIRCLE}
                                        hoverOption={"white"}
                                        enabledBgColor={
                                          "var(--primary-nav-act)"
                                        }
                                        enabledTextColor={"var(--text-primary)"}
                                        disabledBgColor={
                                          "var(--primary-nav-act)"
                                        }
                                        disabledTextColor={
                                          "var(--text-primary)"
                                        }
                                        handleFunction={() => {
                                          navigate(
                                            `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${reimbursementRequestDetailsData?.request?.[0]?.beneficiary_transactions_details?.beneficiary_transaction_id}`,
                                          );
                                        }}
                                        isDisabled={isPopup}
                                      />
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={`h-[var(--stepper-height)] bg-primary-nav ${isPopup ? "hidden" : "Qmd:hidden block"}`}
                ></div>
                <div className="sched-detail-section-mobile flex flex-col Qmd:hidden w-width-full bg-primary-nav ">
                  <div className="sched-name-mobile flex flex-row p-padding-md">
                    <TitleSubtitlePair
                      title={`INR ${formatCurrency(reimbursementRequestDetailsData?.request?.[0]?.requested_amount)}`}
                      titleColor={
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.lifecycle_status === "rejected" ||
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.lifecycle_status === "pending" ||
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.requested_amount ===
                          reimbursementRequestDetailsData?.request?.[0]
                            ?.reimbursement_amount
                          ? "text-primary"
                          : "queued"
                      }
                      subtitle={"Requested amount"}
                      info={false}
                      alignRight={false}
                      hoverOption="white"
                      isBold={true}
                      variant="md"
                    />
                  </div>
                  <hr className="border-primary-bg border-solid mx-margin-md Qmd:mx-margin-base"></hr>
                  {reimbursementRequestDetailsData?.request?.[0]?.approved ===
                    "Y" &&
                    (reimbursementRequestDetailsData?.request?.[0]
                      ?.reimbursement_amount !== undefined ||
                      reimbursementRequestDetailsData?.request?.[0]
                        ?.reimbursement_amount !== null) && (
                      <>
                        <div className="flex flex-row p-padding-md">
                          <TitleSubtitlePair
                            title={`INR ${formatCurrency(reimbursementRequestDetailsData?.request?.[0]?.reimbursement_amount)}`}
                            titleColor="settled"
                            subtitle={"Approved amount"}
                            info={false}
                            alignRight={false}
                            hoverOption="white"
                            isBold={true}
                            variant="md"
                          />
                        </div>
                        <hr className="border-primary-bg border-solid mx-margin-md Qmd:mx-margin-base"></hr>
                      </>
                    )}

                  <div className="sched-amount-mobile flex flex-col p-padding-md">
                    <TitleSubtitlePair
                      title={
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.beneficiary_account_name
                      }
                      titleColor="text-primary"
                      subtitle="Account name"
                      info={false}
                      alignRight={false}
                      hoverOption="white"
                      isBold={false}
                      variant="md"
                    />
                  </div>
                  <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>

                  <div className="sched-accounts-jumbo-div-mobile flex flex-col Qlg:pl-padding-sm py-padding-sm">
                    <div
                      className={`sched-detail-src-acct-logo-mobile flex flex-row items-center  ${isPopup && "opacity-light-opacity"} justify-between`}
                    >
                      <div className="ml-margin-sm lg:ml-0">
                        <TitleSubtitlePair
                          isDisabled={
                            isPopup
                              ? true
                              : !(
                                    services?.includes("RVAccount") ||
                                    services?.includes("Admin")
                                  )
                                ? true
                                : false
                          }
                          alignRight={false}
                          title={formatAccountNumber(
                            reimbursementRequestDetailsData?.request?.[0]
                              ?.beneficiary_account_bank_acc_no,
                          )}
                          titleColor={"text-primary"}
                          subtitle={"Destination account"}
                          onClick={() => {
                            if (isPopup) {
                              CommonToast({
                                text: "Action restricted in popup mode.",
                                icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
                                variant: "var(--error)",
                              });
                            } else {
                              if (
                                services?.includes("RVAccount") ||
                                services?.includes("Admin")
                              ) {
                                setReimburseAccountDetailpop(true);
                                setBeneAccountId(
                                  reimbursementRequestDetailsData?.request?.[0]
                                    ?.beneficiary_account_id,
                                );
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "RVAccount, Admin",
                                  },
                                });
                              }
                            }
                          }}
                          info={false}
                          showArrow={true}
                          hoverOption={"white"}
                          isBold={false}
                          variant={"md"}
                        />
                      </div>
                      <div className="bg-text-primary rounded-full p-padding-sm flex flex-row justify-center items-center px-padding-sm py-padding-button-s mr-margin-md">
                        <CommonBankLogo
                          ifsc={
                            reimbursementRequestDetailsData?.request?.[0]
                              ?.beneficiary_account_ifsc_code
                          }
                          variant="big"
                        />
                      </div>
                    </div>
                  </div>

                  <hr className="border-primary-bg mx-margin-md Qmd:mx-margin-base"></hr>
                  <div className="sched-method-mobile flex flex-col gap-gap-xs p-padding-md">
                    <TitleSubtitlePair
                      isDisabled={false}
                      alignRight={false}
                      title={
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.beneficiary_account_ifsc_code || "N/A"
                      }
                      titleColor={"text-primary"}
                      subtitle={TEXT?.IFSC_CODE}
                      info={false}
                      showArrow={false}
                      isBold={false}
                      variant={"md"}
                    />
                  </div>
                </div>
              </>

              <div className="block Qmd:hidden">
                {/* Mobile  */}
                {scheduleUpdatedData?.transaction?.map((schedule) => {
                  return (
                    <TimelineStatusBar
                      showMobile={true}
                      overrideAutoLoader
                      failedToTakeaction={rejectErrorMessage}
                      failedToTakeactionReason={
                        scheduleUpdatedData?.message || rejectErrorMessage
                      }
                      accountApprovalPending={
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.beneficiary_account_approval_status === "pending" &&
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.lifecycle_status === "pending"
                      }
                      accountApprovalPendingSubHeader={
                        services?.includes("RAAccount")
                          ? "Account is not approved, approve account before approving transaction."
                          : "To approve the account, please contact the authorized person."
                      }
                      handleApprovalPendingBtn={() => {
                        if (services?.includes("RAAccount")) {
                          setShowRequestAccModal(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "RAAccount",
                            },
                          });
                        }
                      }}
                      requestApproval={
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.approved === "Y"
                      }
                      handleRequestApproval={() => {
                        if (
                          services?.includes("VReimbursementTxn") ||
                          services?.includes("Admin")
                        ) {
                          navigate(
                            `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${scheduleUpdatedData?.request?.[0]?.beneficiary_transactions_details?.beneficiary_transaction_id}`,
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "VReimbursementTxn",
                            },
                          });
                        }
                      }}
                      isReqDisable={
                        !services?.includes("VReimbursementTxn") &&
                        !services?.includes("Admin")
                      }
                      isApprovalPendingDisabled={
                        !services?.includes("RAAccount")
                      }
                      rejected={
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.rejected === "Y"
                      }
                      rejectedReason={
                        reimbursementRequestDetailsData?.request?.[0]
                          ?.rejection_reason
                      }
                      pending={
                        !(
                          reimbursementRequestDetailsData?.request?.[0]
                            ?.approved === "Y"
                        ) &&
                        !(
                          reimbursementRequestDetailsData?.request?.[0]
                            ?.rejected === "Y"
                        ) &&
                        !rejectErrorMessage
                      }
                      rejectMobClick={() => {
                        if (hasModService) {
                          setbtnClicked((prev) => ({
                            ...prev,
                            [scheduleUpdatedData?.transaction?.txn_id]:
                              "Reject",
                          }));
                          setShowRejectPrompt(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AReimbursementRequest",
                            },
                          });
                        }
                      }}
                      isRejectMobDisable={
                        !services?.includes("AReimbursementRequest")
                      }
                      approveMobClick={() => {
                        if (services?.includes("AReimbursementRequest")) {
                          const updatedAccountDetails = {
                            request_id: schedule?.request_id,
                            bankAccountName: schedule?.beneficiary_account_name,
                            beneAccountId: schedule?.beneficiary_account_id,
                            bankAccountIFSC:
                              schedule?.beneficiary_account_ifsc_code,
                            bankAccountNo:
                              schedule?.beneficiary_account_bank_acc_no,
                            categories: schedule?.category,
                            amount: schedule?.requested_amount,
                            bankLogo: schedule?.beneficiary_account_ifsc_code,
                            pan: "",
                            ownerId: null,
                            ownerAccountName: "",
                            ownerBankIFSC: null,
                            ownerBankBalance:
                              GlobalConfiguration.lengthCheckZero,
                            ownerBankLogo: null,
                            ownerLastUpdated: null,
                            ownerBankAccountNo: null,
                            selectedCategory: {
                              configuration: schedule?.additional_data,
                            },
                            mergeCategory: schedule?.additional_data?.data,
                            amountWords: "",
                            labels: schedule?.labels || [],
                            ownerLabels: [],
                            comment: "",
                            date: schedule?.reimbursement_date,
                            expenseType: schedule?.expense_type,
                            description:
                              currentAccountDetails?.description ?? "",
                            uploadFile: schedule?.uploaded_file_data,
                          };

                          setcurrentAccountDetails(updatedAccountDetails);

                          navigate(
                            "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
                            {
                              state: {
                                ...updatedAccountDetails,
                                type: "PayReimburseTxn",
                                flow: "PayReimburseTxn",
                                TypeRTGS: "RequestRTGS",
                              },
                            },
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AReimbursementRequest",
                            },
                          });
                        }
                      }}
                      isApproveMobDisable={!hasModService}
                      whichBtnClicked={
                        btnClicked?.[
                          scheduleUpdatedData?.transaction?.txn_id
                        ] || "none"
                      }
                      rejectBtnText={
                        <>
                          Reject <br /> request
                        </>
                      }
                      approveBtnText={
                        <>
                          Approve and <br /> pay
                        </>
                      }
                    />
                  );
                })}
              </div>

              <div className="sched-bottom-section flex flex-row justify-center bg-primary-bg">
                <div
                  className={`sched-bottom-section-inner-1024 max-w-screen-Qlg ${rejectErrorMessage ? "mt-margin-sm" : "mt-margin-md"}  ${!isPopup ? "Qmd:w-max-content-width" : " mr-margin-base "} w-width-full pl-padding-base `}
                >
                  <div className="sched-quick-details-container-mobile block Qmd:hidden">
                    {quickActions}
                  </div>
                  <>
                    <div
                      className={`Qlg:mx-margin-base mx-margin-md flex flex-row mt-margin-md items-end max-w-max-content-width min-h-stepper-header ${rejectErrorMessage ? "mt-margin-sm" : "Qmd:mt-margin-base"} ${
                        !(
                          reimbursementRequestDetailsData?.request?.[0]
                            ?.approved === "Y" ||
                          reimbursementRequestDetailsData?.request?.[0]
                            ?.rejected === "Y"
                        )
                          ? "Qsmd:justify-center"
                          : "justify-start"
                      }`}
                    >
                      <div
                        className={`bg-primary-card rounded-t-border-radius-md  rounded-bl-border-radius-md w-width-full Qlg:w-[calc(var(--graphic-rectangle-height-lg)-(var(--banklogo-height-sm)))] Qmd:w-width-sm  ${reimbursementRequestDetailsData?.request?.[0]?.rejected === "Y" ? "rounded-bl-border-radius-md rounded-br-border-radius-md Qsmd:rounded-br-none" : "Qsmd:rounded-br-none rounded-br-border-radius-md"}`}
                      >
                        <div
                          className={`sched-txn-timeline-status-container ${isPopup && "opacity-light-opacity cursor-not-allowed"} bg-primary-nav relative z-z-index-content rounded-border-radius-md w-width-full ${isPopup ? "cursor-not-allowed" : " "}`}
                        >
                          <div className="text-text-primary text-font-xs text-left font-semibold pt-padding-sm mb-margin-sm px-padding-md">
                            Request timeline
                          </div>
                          <div className="relative left-left-base border-primary-bg border-t-border mx-margin-md"></div>

                          <div
                            ref={leftContentRef}
                            className={`bg-primary-nav group relative  rounded-b-border-radius-md w-full z-z-index-base`}
                          >
                            <CommonTimeLineCard
                              logsData={scheduleUpdatedData?.transaction}
                              handleApprovalClick={handleTimelinePopup}
                              showApprovalTimeline={true}
                              showDistributionTimeline={false}
                              showDistributionRightIcon={true}
                              showApprovalLeftIcon={true}
                              showApprovalDuration={true}
                              showDistributionDuration={false}
                              isDisabled={isPopup}
                              cardType={"single"}
                              leftCardTitle="Stage - Approval"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="hidden Qmd:flex flex-col flex-grow  w-width-md">
                        {scheduleUpdatedData?.transaction?.map((schedule) => {
                          return (
                            <TimelineStatusBar
                              showMobile={false}
                              overrideAutoLoader
                              // isLoading={reimbursementRequestDetailsLoading}
                              failedToTakeaction={rejectErrorMessage}
                              failedToTakeactionReason={
                                scheduleUpdatedData?.message ||
                                rejectErrorMessage
                              }
                              accountApprovalPending={
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.beneficiary_account_approval_status ===
                                  "pending" &&
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.lifecycle_status === "pending"
                              }
                              accountApprovalPendingSubHeader={
                                services?.includes("RAAccount")
                                  ? "Account is not approved, approve account before approving transaction."
                                  : "To approve the account, please contact the authorized person."
                              }
                              handleApprovalPendingBtn={() => {
                                if (services?.includes("RAAccount")) {
                                  setShowRequestAccModal(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "RAAccount",
                                    },
                                  });
                                }
                              }}
                              requestApproval={
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.approved === "Y"
                              }
                              handleRequestApproval={() => {
                                if (
                                  services?.includes("VReimbursementTxn") ||
                                  services?.includes("Admin")
                                ) {
                                  navigate(
                                    `/reimbursement_transaction_dashboard/reimbursement_transaction_view_all/reimbursement_transaction_detail_page/${scheduleUpdatedData?.request?.[0]?.beneficiary_transactions_details?.beneficiary_transaction_id}`,
                                  );
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VReimbursementTxn",
                                    },
                                  });
                                }
                              }}
                              isReqDisable={
                                !services?.includes("VReimbursementTxn") &&
                                !services?.includes("Admin")
                              }
                              isApprovalPendingDisabled={
                                !services?.includes("RAAccount")
                              }
                              rejected={
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.rejected === "Y"
                              }
                              rejectedReason={
                                reimbursementRequestDetailsData?.request?.[0]
                                  ?.rejection_reason
                              }
                              pending={
                                !(
                                  reimbursementRequestDetailsData?.request?.[0]
                                    ?.approved === "Y"
                                ) &&
                                !(
                                  reimbursementRequestDetailsData?.request?.[0]
                                    ?.rejected === "Y"
                                ) &&
                                !rejectErrorMessage
                              }
                              rejectClick={() => {
                                if (hasModService) {
                                  setbtnClicked((prev) => ({
                                    ...prev,
                                    [scheduleUpdatedData?.transaction?.txn_id]:
                                      "Reject",
                                  }));
                                  setShowRejectPrompt(true);
                                  setbtnClicked((prev) => ({
                                    ...prev,
                                    [scheduleUpdatedData?.transaction?.txn_id]:
                                      "Reject",
                                  }));
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService:
                                        "AReimbursementRequest",
                                    },
                                  });
                                }
                              }}
                              isRejectDisable={
                                !services?.includes("AReimbursementRequest")
                              }
                              approveClick={() => {
                                if (
                                  services?.includes("AReimbursementRequest")
                                ) {
                                  const updatedAccountDetails = {
                                    request_id: schedule?.request_id,
                                    bankAccountName:
                                      schedule?.beneficiary_account_name,
                                    beneAccountId:
                                      schedule?.beneficiary_account_id,
                                    bankAccountIFSC:
                                      schedule?.beneficiary_account_ifsc_code,
                                    bankAccountNo:
                                      schedule?.beneficiary_account_bank_acc_no,
                                    categories: schedule?.category,
                                    amount: schedule?.requested_amount,
                                    bankLogo:
                                      schedule?.beneficiary_account_ifsc_code,
                                    pan: "",
                                    ownerId: null,
                                    ownerAccountName: "",
                                    ownerBankIFSC: null,
                                    ownerBankBalance:
                                      GlobalConfiguration.lengthCheckZero,
                                    ownerBankLogo: null,
                                    ownerLastUpdated: null,
                                    ownerBankAccountNo: null,
                                    selectedCategory: {
                                      configuration: schedule?.additional_data,
                                    },
                                    mergeCategory:
                                      schedule?.additional_data?.data,
                                    amountInWords: "",
                                    labels: schedule?.labels || [],
                                    ownerLabels: [],
                                    comment: "",
                                    date: schedule?.reimbursement_date,
                                    expenseType: schedule?.expense_type,
                                    description:
                                      currentAccountDetails?.description ?? "",
                                    uploadFile: schedule?.uploaded_file_data,
                                  };

                                  setcurrentAccountDetails(
                                    updatedAccountDetails,
                                  );

                                  navigate(
                                    "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
                                    {
                                      state: {
                                        ...updatedAccountDetails,
                                        type: "PayReimburseTxn",
                                        flow: "PayReimburseTxn",
                                        TypeRTGS: "RequestRTGS",
                                      },
                                    },
                                  );
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService:
                                        "AReimbursementRequest",
                                    },
                                  });
                                }
                              }}
                              rejectBtnText={
                                <>
                                  Reject <br /> request
                                </>
                              }
                              approveBtnText={
                                <>
                                  Approve and <br /> pay
                                </>
                              }
                              isApproveDisable={!hasModService}
                              whichBtnClicked={
                                btnClicked?.[
                                  scheduleUpdatedData?.transaction?.txn_id
                                ] || "none"
                              }
                            />
                          );
                        })}
                      </div>
                    </div>
                  </>
                  <div className="sched-detail-container w-width-full overflow-x-hidden max-w-screen-Qlg bg-primary-bg  Qsmd:pr-padding-base pl-padding-base">
                    <>
                      <div className="py-padding-md flex pl-padding-md Qlg:pl-padding-base pr-padding-md">
                        <div
                          ref={detailsTabsScrollRef}
                          className="flex gap-gap-sm bg-primary-card w-auto min-w-0 lg:ml-margin-base rounded-border-radius-md overflow-x-auto no-scrollbar [&>div]:shrink-0"
                        >
                          <SwitcherTabs
                            initialActiveTab={selectedDetail}
                            tabs={[
                              ...(isRequestApproved
                                ? [
                                    {
                                      label: "Transaction Details",
                                      key: "Transaction details",
                                      handler: () => {
                                        setSelectedDetail(
                                          "Transaction details",
                                        );
                                        setTabIndex(
                                          GlobalConfiguration.lengthCheckTwo,
                                        );
                                      },
                                    },
                                  ]
                                : []),
                              {
                                label: "Category Specific Details",
                                key: "Additional details",
                                handler: toggleAdditionalDetails,
                              },
                              {
                                label: "Support Details",
                                key: "Details",
                                handler: toggleDetails,
                              },
                            ]}
                            setTabIndex={setTabIndex}
                          />
                        </div>
                      </div>
                    </>
                    <div className="sched-detail-pane mb-margin-md">
                      {renderDetailSection()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
export default ReimbursementTxnRequestDetail;
